import React, { Component } from 'react';

import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { submit, isSubmitting } from 'redux-form';

import { getProperties, getUnits } from 'actions/landlordPropertiesActions';
import { getGroupedVendors } from 'actions/vendorsActions';

import { getTicket, deleteTicket } from 'actions/maintenanceTicketActions';
import * as maintenanceActions from 'actions/maintenanceActions';
import { getCompanyPreferences } from 'actions/companyDetailsActions';

import TableFilters from 'components/ui/TableFilters';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';
import StatusTag from 'components/ui/StatusTag';
import PriorityIcon from 'components/ui/PriorityIcon';

import TicketDetailsOverview from './components/tickets/TicketDetailsOverview';
import AddMaintenanceTicketForm from './components/tickets/AddMaintenanceTicketForm';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Drawer from '@material-ui/core/Drawer';
import { MuiThemeProvider } from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';
import FlatButton from 'material-ui/FlatButton';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import { getTranslatedString } from 'helpers/i18n';
import { colors } from 'helpers/ColorHelper';
import { frequencyHelper } from 'helpers/tableHelpers';
import { toFriendlyDateString } from 'helpers/Formatter';
import { isFilterInStrings } from 'helpers/StringHelper.js';
import { AccentColor } from 'helpers/AccentColorHelper';
import {
  StyledHeader,
  StyledMain,
  StyledHeaderContainer,
  StyledAddButton,
  StyledTableContainer,
} from 'helpers/StyledTableComponentsHelper';
import { drawerStyle } from 'helpers/tableHelpers';

export default withMobileDialog()(
  connect(
    (store) => ({
      fetchingRecurringTickets: store.maintenanceReducer.fetchingRecurringTickets,
      recurringTicketsCount: store.maintenanceReducer.recurringTicketsCounts,
      recurringTickets: store.maintenanceReducer.recurringTickets,
      ticketDetails: store.maintenanceTicket.ticketDetails,
      units: store.landlordProperties.units,
      properties: store.landlordProperties.properties,
      submitting: isSubmitting('add_ticket_form')(store),
      currentLeasesOfUnit: store.landlordProperties.currentLeasesOfUnit,
      companyPreferences: store.companyDetails.companyPreferences,
    }),
    {
      ...maintenanceActions,
      getUnits,
      getProperties,
      submit,
      getTicket,
      deleteTicket,
      getGroupedVendors,
      getCompanyPreferences,
    }
  )(
    class RecurringTickets extends Component {
      constructor(props) {
        super(props);
        this.state = {
          showFilters: false,
          filtersActive: false,
          filters: {
            search: '',
            properties: Array(this.props.properties.length).fill(false),
          },
          currentTab: 'active',
          sortKey: '',
          sortOrder: '',
          offset: 0,
          showDrawer: false,
          drawerIsOpen: false,
        };
      }

      setRef = (ref) => (this.table = ref);

      fetchRecurringTicketsAndStats = () => {
        this.props.getRecurringTicketsCount();
        this.fetchRecurringTickets();
      };

      fetchRecurringTickets = () => {
        const { filters, filtersActive, currentTab, offset, sortKey, sortOrder } = this.state;

        let fetchPromise = null;

        let filterOptions = {
          sort_key: sortKey,
          sort_order: sortOrder,
        };

        if (filtersActive) {
          const propertiesToFilter = this.filterProperties(filters.properties).map(
            (data) => data.value
          );

          filterOptions = {
            query: filters.search,
            property_ids: propertiesToFilter,
            sort_key: sortKey,
            sort_order: sortOrder,
          };

          fetchPromise = this.props.getFilteredRecurringTickets('all', offset, filterOptions);
        } else {
          fetchPromise = this.props.getFilteredRecurringTickets(currentTab, offset, filterOptions);
        }

        fetchPromise.then(() => {
          this.setState({
            offset: this.props.recurringTickets.length,
          });
        });
      };

      componentDidMount = () => {
        this.fetchRecurringTicketsAndStats();
        this.props.getProperties({ for_multiselect: true });
        this.props.getCompanyPreferences();
      };

      filterProperties = (booleanArrayMask) => {
        return this.props.properties.filter((_, i) => booleanArrayMask[i]);
      };

      filterFunctions = {
        search: (valuesToFilterWith) => (item) =>
          valuesToFilterWith.length === 0 ||
          isFilterInStrings(
            this.columns().map((column) => item[column.dataKey]),
            valuesToFilterWith
          ),
        properties: (valuesToFilterWith) => (item) => {
          const propertiesToFilter = this.filterProperties(valuesToFilterWith).map(
            (data) => data.label
          );
          if (propertiesToFilter.length === 0) return true;
          return propertiesToFilter
            .map((property) => property.toLowerCase())
            .includes(item.property_name.toLowerCase());
        },
      };

      handleClearSearch = (setFieldValue) => {
        this.setState(
          {
            filtersActive: false,
            filters: {
              search: '',
              properties: Array(this.props.properties.length).fill(false),
            },
            offset: 0,
          },
          () => this.fetchRecurringTickets()
        );

        if (this.table) this.table.scrollToTop(0);
        setFieldValue('search', '');
        setFieldValue('properties', Array(this.props.properties.length).fill(false));
      };

      handleFilters = (values) => {
        const isFiltersUntouched = values.search === '' && !values.properties.includes(true);
        const newState = {
          filtersActive: !isFiltersUntouched,
          filters: {
            search: values.search,
            properties: values.properties,
          },
          drawerVisible: false,
          offset: 0,
        };

        if (this.table) this.table.scrollToTop(0);
        this.setState(newState, () => this.fetchRecurringTickets());
      };

      handleSort = (key, order) => {
        this.setState(
          {
            sortKey: key,
            sortOrder: order,
            offset: 0,
          },
          () => {
            this.fetchRecurringTickets();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      columns = () => {
        return [
          {
            title: getTranslatedString('recurringTickets.priority'),
            dataKey: 'priority',
            sortable: true,
            width: 75,
            render: ({ data }) => <PriorityIcon priority={data} />,
          },
          {
            title: getTranslatedString('recurringTickets.status'),
            dataKey: 'status',
            sortable: false,
            width: 150,
            render: ({ data }) => <StatusTag status={data} />,
          },
          {
            title: getTranslatedString('recurringTickets.name'),
            dataKey: 'name',
            sortable: true,
            width: 250,
          },
          {
            title: getTranslatedString('recurringTickets.nextTriggerDate'),
            dataKey: 'next_run_date',
            sortable: true,
            width: 175,
            render: ({ data }) => toFriendlyDateString(data) || getTranslatedString('none'),
          },
          {
            title: getTranslatedString('recurringTickets.frequency'),
            dataKey: 'frequency_type',
            sortable: true,
            width: 175,
            render: ({ data, rowData }) => frequencyHelper(data, rowData.frequency),
          },
          {
            title: getTranslatedString('recurringTickets.endDate'),
            dataKey: 'end_date',
            sortable: true,
            width: 175,
            render: ({ data }) => toFriendlyDateString(data) || getTranslatedString('none'),
          },
          {
            title: getTranslatedString('recurringTickets.assignedTo'),
            dataKey: 'assigned_to_name',
            sortable: true,
            width: 300,
            render: ({ data }) => data || getTranslatedString('none'),
          },
        ];
      };

      handleTabChange = (tabName) => {
        this.setState(
          {
            currentTab: tabName,
            offset: 0,
          },
          () => {
            this.fetchRecurringTickets();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      onSuccessChange = () => {
        this.setState(
          {
            offset: 0,
          },
          () => {
            this.fetchRecurringTicketsAndStats();
          }
        );
        if (this.table) this.table.scrollToTop(0);
      };

      accentColor = AccentColor();

      filterOptions = [
        {
          useSearch: true,
          options: this.props.properties.map((data) => data.label),
          name: 'properties',
          title: 'Select properties to filter by',
        },
      ];

      toggleAddTicket = () => {
        this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
      };

      updateMaintenanceTemplate = (formData, templateID) => {
        return this.props.updateMaintenanceTemplate(templateID, formData).then(() => {
          this.setState(
            {
              offset: 0,
            },
            () => {
              this.fetchRecurringTicketsAndStats();
            }
          );
          if (this.table) this.table.scrollToTop(0);
        });
      };

      toggleDrawer = async (maintenanceTicketID) => {
        if (!this.state.showDrawer && maintenanceTicketID) {
          await this.props.getTicket(maintenanceTicketID);
          const propertyId = this.props.ticketDetails.property_id;
          this.props.getUnits(propertyId, { for_multiselect: true });
          this.props.getMaintenanceCategories(propertyId);
          this.props.getMaintenanceLocations(propertyId);
          this.props.getGroupedVendors();
          this.setState({
            showDrawer: true,
          });
          return;
        }

        this.setState({
          showDrawer: false,
        });
      };

      onPropertySelect = (properties) => {
        this.setState({
          selectedProperties: properties.map((property) => property.label),
          selectedPropertiesMultiSelect: properties,
          filteredValue: '',
          typeFilter: '',
          tableData: this.props.maintenanceTickets,
        });

        this.filterByProperty(
          properties.map((property) => property.label),
          this.props.maintenanceTickets
        );
      };

      addTicket = (formData) => {
        return this.props.createOrUpdateMaintenanceTicket(formData).then(() => {
          this.toggleAddTicket();
          this.setState(
            {
              offset: 0,
            },
            () => {
              this.fetchRecurringTicketsAndStats();
            }
          );
          if (this.table) this.table.scrollToTop(0);
        });
      };

      updateTicket = (formData, ticketID) => {
        if (ticketID) {
          return this.props.createOrUpdateMaintenanceTicket(formData, ticketID).then(() => {
            this.getMaintenanceTemplates();
          });
        }

        return this.props
          .createOrUpdateMaintenanceTicket(formData, this.props.ticketDetails.id)
          .then(() => {
            this.setState(
              {
                offset: 0,
              },
              () => {
                this.fetchRecurringTicketsAndStats();
              }
            );
            if (this.table) this.table.scrollToTop(0);
            this.props.getTicket(this.props.ticketDetails.id);
          });
      };

      deleteTicket = () => {
        return this.props.deleteTicket(this.props.ticketDetails.id).then(() => {
          this.toggleDrawer();
          this.setState(
            {
              offset: 0,
            },
            () => {
              this.fetchRecurringTicketsAndStats();
            }
          );
          if (this.table) this.table.scrollToTop(0);
        });
      };

      createOrUpdateTask = (task, taskID) => {
        this.props.createOrUpdateMaintenanceTask(task, taskID, this.props.ticketDetails.id);
      };

      deleteTask = (taskId) => {
        this.props.deleteTask(taskId, this.props.ticketDetails.id);
      };

      render() {
        const { filters } = this.state;
        const { recurringTickets, recurringTicketsCount } = this.props;

        const filterOptions = [
          {
            useSearch: true,
            options: this.props.properties.map((data) => data.label),
            name: 'properties',
            title: 'Select properties to filter by',
          },
        ];

        const tabs = [
          {
            title: getTranslatedString('recurringTickets.active'),
            label: getTranslatedString('recurringTickets.active'),
            value: 'active',
            count: recurringTicketsCount['active'] || 0,
            onClick: () => this.handleTabChange('active', { subset: 'active' }),
          },
          {
            title: getTranslatedString('recurringTickets.inactive'),
            label: getTranslatedString('recurringTickets.inactive'),
            value: 'inactive',
            count: recurringTicketsCount['inactive'] || 0,
            onClick: () => this.handleTabChange('inactive', { subset: 'inactive' }),
          },
          {
            title: getTranslatedString('recurringTickets.all'),
            label: getTranslatedString('recurringTickets.all'),
            value: 'all',
            count: recurringTicketsCount['all'] || 0,
            onClick: () => this.handleTabChange('all', { subset: 'all' }),
          },
        ];

        return (
          <StyledMain>
            <StyledHeaderContainer>
              <StyledHeader>
                <MediaQuery query="(max-device-width: 750px)">
                  <HeaderWithPeriod
                    headerText={<span>{getTranslatedString('recurringTickets.shortTitle')}</span>}
                    newStyle
                  />
                </MediaQuery>
                <MediaQuery query="(min-device-width: 750px)">
                  <HeaderWithPeriod
                    headerText={<span>{getTranslatedString('recurringTickets.title')}</span>}
                    newStyle
                  />
                </MediaQuery>
                <StyledAddButton accentColor={this.accentColor} onClick={this.toggleAddTicket}>
                  {getTranslatedString('recurringTickets.addTicket')}
                </StyledAddButton>
              </StyledHeader>
              <TableFilters
                filters={filters}
                handleSubmitFilters={this.handleFilters}
                handleClearFilters={this.handleClearSearch}
                filterOptions={filterOptions}
                accentColor={this.accentColor}
              />
            </StyledHeaderContainer>

            {this.addRecurringTicketDialog()}
            {this.renderTemplateDetails()}

            <StyledTableContainer>
              {this._renderTableView({ recurringTickets, tabs })}
              {this._renderMobileView({
                recurringTickets,
                tabs,
                currentTab: this.state.currentTab,
                tabChange: this.handleTabChange,
              })}
            </StyledTableContainer>
          </StyledMain>
        );
      }

      addRecurringTicketDialog = () => (
        <Dialog
          disableBackdropClick
          fullScreen={this.props.fullScreen}
          open={this.state.drawerIsOpen}
          onClose={this.toggleAddTicket}
          aria-labelledby="add-new-template"
        >
          <DialogTitle id="add-new-template">
            <h3 style={{ textAlign: 'center', margin: 0 }}>Add Recurring Ticket</h3>
          </DialogTitle>
          <DialogContent style={{ padding: 0 }}>
            <AddMaintenanceTicketForm
              onSubmit={this.addTicket}
              formName="add_ticket_form"
              showRecurrance
              initialValues={{ hide_from_tenant: false }}
            />
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.toggleAddTicket}
              id="close-button"
              style={{ color: AccentColor() }}
            >
              CANCEL
            </FlatButton>
            <FlatButton
              variant="raised"
              onClick={() => this.props.submit('add_ticket_form')}
              disabled={this.props.submitting}
              id="submit-button"
              style={{
                color: 'white',
                backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
              }}
            >
              SAVE
            </FlatButton>
          </DialogActions>
        </Dialog>
      );

      renderTemplateDetails = () => (
        <MuiThemeProvider theme={createMuiTheme(drawerStyle)}>
          <Drawer open={this.state.showDrawer} onClose={this.toggleDrawer} anchor="left">
            <TicketDetailsOverview
              toggleDrawer={this.toggleDrawer}
              maintenanceTicket={this.props.ticketDetails}
              updateTicket={this.updateTicket}
              deleteAction={this.deleteTicket}
              createOrUpdateTask={this.createOrUpdateTask}
              deleteTask={this.deleteTask}
              companyPreferences={this.props.companyPreferences}
              showRecurrance
              hideDelete
            />
          </Drawer>
        </MuiThemeProvider>
      );

      _renderMobileView = ({ recurringTickets, tabs, currentTab, tabChange }) => (
        <MediaQuery query="(max-device-width: 750px)">
          <MobileTable
            groupRowsBy="property_name"
            data={recurringTickets}
            tabs={tabs}
            tabIndex={currentTab}
            tabChange={tabChange}
            filtersActive={this.state.filtersActive}
            columns={this.columns()}
            title="name"
            tag="status"
            stickyHeaderTop={this.state.filters.search ? '137px' : '107px'}
            fieldsAboveFold={[
              {
                title: getTranslatedString('recurringTickets.nextTriggerDate'),
                key: 'next_run_date',
              },
            ]}
            fieldsBelowFold={[
              {
                title: getTranslatedString('recurringTickets.endDate'),
                key: 'end_date',
              },
              {
                title: getTranslatedString('recurringTickets.assignedTo'),
                key: 'assigned_to_name',
              },
            ]}
            onRowClick={(data) => {
              this.toggleDrawer(data.id);
            }}
          />
        </MediaQuery>
      );

      _renderTableView = ({ recurringTickets, tabs }) => (
        <MediaQuery query="(min-device-width: 750px)">
          <TabbedTable
            setRef={this.setRef}
            groupRowsBy="property_name"
            tabs={tabs}
            columns={this.columns()}
            data={recurringTickets}
            loadMoreData={this.fetchRecurringTickets}
            isLoading={this.props.fetchingRecurringTickets}
            filtersActive={this.state.filtersActive}
            onRowClick={(data) => {
              this.toggleDrawer(data.original_id);
            }}
            onColumnClick={(data) => {
              this.handleSort(data.key, data.order);
            }}
          />
        </MediaQuery>
      );
    }
  )
);
